import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

import { SITE_CONFIG } from "@/lib/constants";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: string | Date): string {
  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(new Date(date));
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .trim();
}

export function estimateReadingTime(content: string): number {
  const wordsPerMinute = 200;
  const words = content.split(/\s+/).length;
  return Math.ceil(words / wordsPerMinute);
}

export function absoluteUrl(path: string): string {
  // Single source of truth: matches canonical/OG/sitemap (SITE_CONFIG.url).
  return `${SITE_CONFIG.url}${path}`;
}

/** Append UTM tracking parameters to an external URL. */
export function withUtm(
  url: string,
  {
    source = "tutorials.co.uk",
    medium = "referral",
    campaign = "website",
  }: { source?: string; medium?: string; campaign?: string } = {},
): string {
  const u = new URL(url);
  u.searchParams.set("utm_source", source);
  u.searchParams.set("utm_medium", medium);
  u.searchParams.set("utm_campaign", campaign);
  return u.toString();
}
